module.exports = __webpack_public_path__ + "img/no-data-icon copy.e5359bd3.png";